export enum AppLanguage {
  English = 'en',
  Chinese = 'zh',
  Japanese = 'ja',
}
